export interface ScreenAndProtectEnrollmentResponse {
  agencyUid: string;
  isActive: boolean;
  activeSince: string | null;
  // top-level properties only
  propertiesUids: string[];
}

export interface ScreenAndProtectEnrollPayload {
  agencyUid: string;
  // top-level properties only
  propertiesUids: string[];
}

export enum LeadScreenAndProtectStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  FLAGGED = 'FLAGGED',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
}

export interface LeadScreenAndProtectDetails {
  protectionAmount: number;
  status: LeadScreenAndProtectStatus;
  flaggedReason?: string | null;
  expirationDate: string;
  requestUrl?: string | null;
}

export interface LeadScreenAndProtectDetailsResponse
  extends LeadScreenAndProtectDetails {}
